import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";

import { AppRoutes } from "../routes";

// pages
// import Presentation from "./Presentation";
import Upgrade from "./Upgrade";
import DashboardOverview from "./dashboard/DashboardOverview";
import Transactions from "./Transactions";
import Settings from "./Settings";
import BootstrapTables from "./tables/BootstrapTables";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";

// documentation pages
import DocsOverview from "./documentation/DocsOverview";
import DocsDownload from "./documentation/DocsDownload";
import DocsQuickStart from "./documentation/DocsQuickStart";
import DocsLicense from "./documentation/DocsLicense";
import DocsFolderStructure from "./documentation/DocsFolderStructure";
import DocsBuild from "./documentation/DocsBuild";
import DocsChangelog from "./documentation/DocsChangelog";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Preloader from "../components/Preloader";

import Accordion from "./components/Accordion";
import Alerts from "./components/Alerts";
import Badges from "./components/Badges";
import Breadcrumbs from "./components/Breadcrumbs";
import Buttons from "./components/Buttons";
import Forms from "./components/Forms";
import Modals from "./components/Modals";
import Navs from "./components/Navs";
import Navbars from "./components/Navbars";
import Pagination from "./components/Pagination";
import Popovers from "./components/Popovers";
import Progress from "./components/Progress";
import Tables from "./components/Tables";
import Tabs from "./components/Tabs";
import Tooltips from "./components/Tooltips";
import Toasts from "./components/Toasts";
import Reservations from './Reservations';

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => (<> <Preloader show={loaded ? false : true} /> <Component {...props} /> </>)} />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <Preloader show={loaded ? false : true} />
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} />
          {/* <Footer toggleSettings={toggleSettings} showSettings={showSettings} /> */}
        </main>
      </>
    )}
    />
  );
};

export default () => (
  <Switch>
    {/* <RouteWithLoader exact path={AppRoutes.Presentation.path} component={Presentation} /> */}
    <RouteWithLoader exact path={AppRoutes.Signin.path} component={Signin} />
    <RouteWithLoader exact path={AppRoutes.Signup.path} component={Signup} />
    <RouteWithLoader exact path={AppRoutes.ForgotPassword.path} component={ForgotPassword} />
    <RouteWithLoader exact path={AppRoutes.ResetPassword.path} component={ResetPassword} />
    <RouteWithLoader exact path={AppRoutes.Lock.path} component={Lock} />
    <RouteWithLoader exact path={AppRoutes.NotFound.path} component={NotFoundPage} />
    <RouteWithLoader exact path={AppRoutes.ServerError.path} component={ServerError} />

    {/* pages */}
    <RouteWithSidebar exact path={AppRoutes.DashboardOverview.path} component={DashboardOverview} />
    <RouteWithSidebar exact path={AppRoutes.Upgrade.path} component={Upgrade} />
    <RouteWithSidebar exact path={AppRoutes.Transactions.path} component={Transactions} />
    <RouteWithSidebar exact path={AppRoutes.Reservations.path} component={Reservations} />
    <RouteWithSidebar exact path={AppRoutes.Settings.path} component={Settings} />
    <RouteWithSidebar exact path={AppRoutes.BootstrapTables.path} component={BootstrapTables} />

    {/* components */}
    <RouteWithSidebar exact path={AppRoutes.Accordions.path} component={Accordion} />
    <RouteWithSidebar exact path={AppRoutes.Alerts.path} component={Alerts} />
    <RouteWithSidebar exact path={AppRoutes.Badges.path} component={Badges} />
    <RouteWithSidebar exact path={AppRoutes.Breadcrumbs.path} component={Breadcrumbs} />
    <RouteWithSidebar exact path={AppRoutes.Buttons.path} component={Buttons} />
    <RouteWithSidebar exact path={AppRoutes.Forms.path} component={Forms} />
    <RouteWithSidebar exact path={AppRoutes.Modals.path} component={Modals} />
    <RouteWithSidebar exact path={AppRoutes.Navs.path} component={Navs} />
    <RouteWithSidebar exact path={AppRoutes.Navbars.path} component={Navbars} />
    <RouteWithSidebar exact path={AppRoutes.Pagination.path} component={Pagination} />
    <RouteWithSidebar exact path={AppRoutes.Popovers.path} component={Popovers} />
    <RouteWithSidebar exact path={AppRoutes.Progress.path} component={Progress} />
    <RouteWithSidebar exact path={AppRoutes.Tables.path} component={Tables} />
    <RouteWithSidebar exact path={AppRoutes.Tabs.path} component={Tabs} />
    <RouteWithSidebar exact path={AppRoutes.Tooltips.path} component={Tooltips} />
    <RouteWithSidebar exact path={AppRoutes.Toasts.path} component={Toasts} />

    {/* documentation */}
    <RouteWithSidebar exact path={AppRoutes.DocsOverview.path} component={DocsOverview} />
    <RouteWithSidebar exact path={AppRoutes.DocsDownload.path} component={DocsDownload} />
    <RouteWithSidebar exact path={AppRoutes.DocsQuickStart.path} component={DocsQuickStart} />
    <RouteWithSidebar exact path={AppRoutes.DocsLicense.path} component={DocsLicense} />
    <RouteWithSidebar exact path={AppRoutes.DocsFolderStructure.path} component={DocsFolderStructure} />
    <RouteWithSidebar exact path={AppRoutes.DocsBuild.path} component={DocsBuild} />
    <RouteWithSidebar exact path={AppRoutes.DocsChangelog.path} component={DocsChangelog} />
    <Redirect to={AppRoutes.NotFound.path} />

    {/* <Navigate to={AppRoutes.NotFound.path} /> */}
  </Switch>
);
